import { useMutation } from '@tanstack/react-query';
import { AuthError } from '@supabase/supabase-js';

import { supabaseClient } from 'src/auth/supabase';

export const useUpdatePasswordSupabase = () =>
    useMutation<void, AuthError, { password: string }>({
        mutationFn: async ({ password }) => {
            const { error } = await supabaseClient.auth.updateUser({ password });
            if (error) throw error;
        },
    });
